import { RootState } from "../../../index";

export const whatsappConfigData = (state: RootState) => state?.whatsappSettings?.data?.whatsappConfigData;
export const whatsappConfigList = (state: RootState) => state.whatsappSettings?.data?.whatsappConfigList;